import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import styled from 'styled-components';

const ResetContainer = styled(Paper)`
  padding: 40px;
  margin-top: 40px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      // Validar senha
      if (!formData.password || formData.password.length < 6) {
        throw new Error('A senha deve ter pelo menos 6 caracteres');
      }

      // Validar confirmação de senha
      if (formData.password !== formData.confirmPassword) {
        throw new Error('As senhas não coincidem');
      }

      const response = await fetch(`/api/auth/reset-password/${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (response.status === 400) {
          throw new Error('Token inválido ou expirado');
        } else {
          throw new Error(data.message || 'Erro ao redefinir senha');
        }
      }

      setSuccess('Senha redefinida com sucesso! Redirecionando para o login...');
      
      // Redirecionar para o login após 2 segundos
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <ResetContainer elevation={3}>
        <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
          Redefinir Senha
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {success}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <TextField
            label="Nova Senha"
            type="password"
            fullWidth
            required
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            error={!!error && error.includes('senha')}
            helperText={error && error.includes('senha') ? error : 'Mínimo de 6 caracteres'}
            disabled={loading}
          />
          <TextField
            label="Confirmar Nova Senha"
            type="password"
            fullWidth
            required
            value={formData.confirmPassword}
            onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
            error={!!error && error.includes('coincidem')}
            helperText={error && error.includes('coincidem') ? error : ''}
            disabled={loading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? 'Redefinindo...' : 'Redefinir Senha'}
          </Button>
        </Form>
      </ResetContainer>
    </Container>
  );
};

export default ResetPassword; 